import { defineComponent } from "vue";
import BaseFooter from "@/components/Shared/BaseFooter/BaseFooter.vue";
import ThemesHelper from "@/helpers/ThemesHelper";
import ButtonStartTest from "@/components/Shared/Home/ButtonStartTest/ButtonStartTest.vue";
import ButtonExternalLink from "@/components/Shared/ButtonExternalLink/ButtonExternalLink.vue";

export default defineComponent({
  components: {
    BaseFooter,
    ButtonStartTest,
    ButtonExternalLink,
  },
  data() {
    return {
      testName: ThemesHelper.getThemeParams("testName"),
      testImage: ThemesHelper.getThemeParams("urlPathTestImage"),
    };
  },
  mounted() {
    this.testImage = require(`@/assets/themes/${this.testImage}`);
  },
  methods: {
    goAhead() {
      this.$router.push({ name: "RegisterTestHiv" });
    },
  },
});
